import { Module, Mutation, VuexModule } from 'vuex-module-decorators'

export interface INotification {
  message: string;
  timeout?: number;
  center: boolean;
  continueShopping: string;
  goToCart: string;
}

@Module({ namespaced: true })
export default class NotificationsModule extends VuexModule {
  public all: INotification[] = []

  @Mutation
  public add(notification: INotification) {
    this.all.push(notification)
  }

  @Mutation
  public removeByIndex(index: number) {
    if (index < this.all.length - 1) return

    this.all.splice(index, 1)
  }
}
